export default {"src":"/_next/static/media/dragdrop.3edd9435.svg","height":48,"width":57,"blurWidth":0,"blurHeight":0};